'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BREAKPOINTS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BREAKPOINTS = exports.BREAKPOINTS = {
    MOBILE_XS: {
        name: 'mobile-xs',
        value: 320
    },
    MOBILE: {
        name: 'mobile',
        value: 627
    },
    TABLET: {
        name: 'tablet',
        value: 960
    },
    TABLET_HORIZONTAL: {
        name: 'tablet-horizontal',
        value: 1260
    },
    DESKTOP: {
        name: 'desktop',
        value: 1600
    },
    DESKTOP_XL: {
        name: 'desktop-xl'
    }
};

var VIEWPORT_WATCHER_SETTINGS = exports.VIEWPORT_WATCHER_SETTINGS = {
    BREAKPOINTS: (_BREAKPOINTS = {}, _defineProperty(_BREAKPOINTS, BREAKPOINTS.MOBILE_XS.name, '(max-width: ' + (BREAKPOINTS.MOBILE_XS.value - 1) + 'px)'), _defineProperty(_BREAKPOINTS, BREAKPOINTS.MOBILE.name, '(min-width: ' + BREAKPOINTS.MOBILE_XS.value + 'px) and (max-width:' + (BREAKPOINTS.MOBILE.value - 1) + 'px)'), _defineProperty(_BREAKPOINTS, BREAKPOINTS.TABLET.name, '(min-width: ' + BREAKPOINTS.MOBILE.value + 'px) and (max-width: ' + (BREAKPOINTS.TABLET.value - 1) + 'px)'), _defineProperty(_BREAKPOINTS, BREAKPOINTS.TABLET_HORIZONTAL.name, '(min-width: ' + BREAKPOINTS.TABLET.value + 'px) and (max-width: ' + (BREAKPOINTS.TABLET_HORIZONTAL.value - 1) + 'px)'), _defineProperty(_BREAKPOINTS, BREAKPOINTS.DESKTOP.name, '(min-width: ' + BREAKPOINTS.TABLET_HORIZONTAL.value + 'px) and (max-width: ' + (BREAKPOINTS.DESKTOP.value - 1) + 'px)'), _defineProperty(_BREAKPOINTS, BREAKPOINTS.DESKTOP_XL.name, '(min-width: ' + BREAKPOINTS.DESKTOP.value + 'px)'), _BREAKPOINTS),
    ORIENTATIONS: {
        'portrait': '(orientation: portrait)',
        'landscape': '(orientation: landscape)'
    }
};